/**
 * @generated SignedSource<<7d849eeebf5a13f66b88dfa07552e15a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type RedemptionTypeStatus = "AVAILABLE" | "OFFLINE" | "REQUIRES_VERIFICATION";
export type PayPalRewardsQuery$variables = {
  redemptionType: RedemptionTypeKey;
  redirectUrl: string;
};
export type PayPalRewardsQuery$data = {
  readonly redemptionOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly amountDenominations: ReadonlyArray<{
          readonly panelistCost: {
            readonly subUnitAmount: number;
          };
        }> | null;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"useRedemptionOptionItemQuery_optionRef">;
      };
    }>;
  } | null;
  readonly redemptionTypes: {
    readonly types: ReadonlyArray<{
      readonly linkNewAccountUrl: string | null;
      readonly name: RedemptionTypeKey;
      readonly status: RedemptionTypeStatus;
    }>;
  } | null;
};
export type PayPalRewardsQuery = {
  response: PayPalRewardsQuery$data;
  variables: PayPalRewardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redemptionType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redirectUrl"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "redirectUrl",
          "variableName": "redirectUrl"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "linkNewAccountUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "redemptionType",
        "variableName": "redemptionType"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AmountDenomination",
  "kind": "LinkedField",
  "name": "amountDenominations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "panelistCost",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PayPalRewardsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionType",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useRedemptionOptionItemQuery_optionRef"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PayPalRewardsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionType",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a7e211a39efff54eac5f0cab83d1fc0",
    "id": null,
    "metadata": {},
    "name": "PayPalRewardsQuery",
    "operationKind": "query",
    "text": "query PayPalRewardsQuery(\n  $redemptionType: RedemptionTypeKey!\n  $redirectUrl: String!\n) {\n  redemptionTypes {\n    types {\n      name\n      linkNewAccountUrl(input: {redirectUrl: $redirectUrl})\n      status\n      id\n    }\n    id\n  }\n  redemptionOptions(input: {redemptionType: $redemptionType}) {\n    edges {\n      node {\n        id\n        name\n        amountDenominations {\n          panelistCost {\n            subUnitAmount\n          }\n        }\n        ...useRedemptionOptionItemQuery_optionRef\n      }\n    }\n  }\n}\n\nfragment useRedemptionOptionItemQuery_optionRef on RedemptionOptionData {\n  imageUrl\n  key\n  name\n}\n"
  }
};
})();

(node as any).hash = "6d128139c3fb74d8e2bd1bf567e742c2";

export default node;
